<template>
  <b-modal
    id="modalDownloadDocumentsData"
    ref="modalDownloadDocumentsData"
    :no-enforce-focus="true"
    :no-close-on-backdrop = 'true'
    size='lg'
    @hidden="modalDownloadDocumentsDataOnHidden"
  >
    <div slot="modal-title">
      {{ modalTitle | translate }}
    </div>
    <div class="mb-3">
      <p>
        {{ 'Select the documents for the report' | translate }}
      </p>
      <p>
        {{ 'If you do not select any document, the report will consider all existing company documents' | translate }}.
      </p>
      <p>
        {{ 'Once the download has been requested, the system will generate an Excel file containing the required data.' | translate }}
      </p>
      <p>
        {{ 'When the required file is ready, the download link will be displayed in the in bar by pressing the icon' | translate }} <i class="fas fa-cloud-download-alt"></i>
      </p>
    </div>
    <b-form>
      <!--<b-form-row>
         <form-thux-horizontal-datetime
          :validator="$v.printForm.date_end__gte"
          :label-form="'Minimum date (optional)' | translate"
          labelColsSm="3"
          labelColsLg="3"
          class-form="col-lg-12 mb-2 mt-2"
          type="date"
          :value="dateRef"
          :placeholder="$t('Leave empty to export all data')"
          @change="setMinDate"
        />
      </b-form-row> -->
      <thux-list-component
      :fields="getFields"
      :pagination="getPaginationFields"
      @select-per-page="changePerPage"
      @change-page="changePage"
      :action-select="getActionSelectFields"
      @select-action="setAction"
      @select-or-deselect-all-queryset="selectOrDeselectAllQueryset"
      @do-action="doAction($event, fieldName)"
      :advanced-search="getAdvancedSearchFields"
      @show-advanced-search="openAdvancedSearch"
    >
      <template slot="body">
        <component-table
          :list="list.results"
          :goBack="goBack"
          :params="tableParams"
        />
      </template>
    </thux-list-component>
    </b-form>
    <div slot="modal-footer">
      <b-btn class="mr-3" variant="default" @click.prevent="closeAndGoToList()">
        {{ 'Cancel' | translate }}
      </b-btn>
      <b-btn
        variant="primary"
        :disabled="$v.printForm.$invalid"
        @click.prevent="closeAndGenerateJob()"
      >
        {{ 'OK' | translate }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as DOCUMENT_TYPES } from '../../document/document/store'
import ThuxListMixin from '@/components/thux-list/ThuxListMixin'

import CompanyDocumentsTable from './CompanyDocumentsTable'
// import FormThuxHorizontalDatetime from '@/components/form-thux-horizontal-components/FormThuxHorizontalDatetimePicker'

export default {
  name: 'DownloadDocumentsDataModal',
  props: ['documentType'],
  mixins: [ThuxListMixin],
  data () {
    return {
      selectedItemId: undefined,
      showCommonFilters: false,
      showAdvancedSearch: false,
      toggleAdvancedSearch: false,
      showStaffList: false,
      printForm: {},
      dateRef: undefined,
      searchFields: [
      /*
      {
          key: 'filter__name__icontains',
          placeholder: this.$t('Name contains'),
          type: 'text',
          col: 6
        },
        {
          key: 'filter__acronym__icontains',
          placeholder: this.$t('Acronym contains'),
          type: 'text',
          col: 6
        }
      */
      ]
    }
  },
  components: {
    'component-table': CompanyDocumentsTable
    // 'form-thux-horizontal-datetime': FormThuxHorizontalDatetime
  },
  created () { },
  mounted () {
    this.openModalDownloadDocumentsData()
  },
  computed: {
    ...mapGetters({
      ...DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS,
      selectedList: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.selectedList
    }),
    modalTitle () {
      return this.$t('Select reference documents')
    },
    message () {
      return this.$t('Select the personnel whose required documents you want to download. If no name is selected, the documents of all staff will be downloaded.')
    },
    getAdvancedSearchFields () {
      return {
        showAdvancedSearch: this.showAdvancedSearch,
        toggleAdvancedSearch: this.toggleAdvancedSearch,
        searchFields: this.searchFields
      }
    }
  },
  methods: {
    ...mapActions({
      ...DOCUMENT_TYPES.GENERIC.document.document.LIST.ACTIONS,
      getCompanyDocuments: 'GENERIC/document/document/getCompanyDocuments'
    }),
    getComponentList (filters = {}) {
      return this.setFilters({ ...filters, filter__document_type__name: this.documentType?.toUpperCase(), order_by: 'name' })
    },
    openModalDownloadDocumentsData () {
      this.$refs.modalDownloadDocumentsData.show()
    },
    modalDownloadDocumentsDataOnHidden (evt) {
      this.$emit('close-modal')
    },
    closeAndGoToList (evt) {
      this.$emit('close-modal')
    },
    setMinDate (evt) {
      const date = evt.date
      this.$set(this.printForm, 'date_end__gte', date ? date.format('YYYY-MM-DD') : undefined)
    },
    closeAndGenerateJob () {
      this.printForm.documents_id = this.selectedList.map(item => item.id)
      this.$emit('generate-job', this.printForm)
    }
  },
  validations () {
    const vals = {
      printForm: { documents_id: [], date_end__gte: { } }
    }
    return vals
  }
}
</script>
